// removed by extract-text-webpack-plugin
module.exports = {"title":"AreaSelection__title__x79uQ"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/AreaSelection/AreaSelection.scss
// module id = 1658
// module chunks = 0